import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Logo = _resolveComponent("Logo")
  const _component_FavIcon = _resolveComponent("FavIcon")

  return ($options.file_icon)
    ? (_openBlock(), _createBlock(_component_FileIcon, {
        key: 0,
        "font-size": "0.5rem",
        width: "1.7rem",
        height: "1.8rem",
        ext: $props.data.name.split('.').pop()
      }, null, 8 /* PROPS */, ["ext"]))
    : ($options.type === 'genrate')
      ? (_openBlock(), _createBlock(_component_Logo, {
          key: 1,
          type: "fat-icon",
          size: "1.6rem"
        }))
      : (_openBlock(), _createBlock(_component_FavIcon, {
          key: 2,
          src: $options.favicon_src,
          size: "1.6rem"
        }, null, 8 /* PROPS */, ["src"]))
}